import React from "react";
import '../main.css'
import axios from 'axios'
import CommonHeader from '../common/Head'



class contactForm extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {firstname:'', lastname:'',compname:'',email:'',comments:'',Resp:''};		
		this.handleChange=this.handleChange.bind(this);			
		this.handleSubmit=this.handleSubmit.bind(this)		
	}

	
	handleChange = event => {	
		const {name, value} = event.target		
		this.setState({[name]: value})			
	}
	
	handleSubmit = event => {
		event.preventDefault()		
		const {firstname, lastname,compname,email,comments} = this.state			
		if(this.state.firstname == "") {
			alert('Please enter your first name')
			return false
		}			
		if(this.state.lastname == "") {
			alert('Please enter your last name')
			return false
		} 	
		if(this.state.compname == "") {
			alert('Please enter your contact subject information')
			return false
		} 
		if(this.state.email == "") {
			alert('Please enter your email address')
			return false
		} 
		if(this.state.comments == "") {
			alert('Please let us know what you want to know about our company')
			return false
		} 
		const userObject={
				firstname:this.state.firstname,	
				lastname: this.state.lastname,
				compname: this.state.compname,
				email: this.state.email,
				comments:this.state.comments
			}
			axios.post(process.env.REACT_APP_API_ENV+'api/contactform.php', userObject)
				.then((res) => {						
					this.setState({Resp:res.data});											
				}).catch((error) => {
					console.log(error)
				});
	}
	
	render() {							
		return (
			<div>				
				<CommonHeader titles="Contact"/>
				<form onSubmit={this.handleSubmit}>							
					<label><h2>First Name</h2></label>							
					<input name="firstname" id="firstname" style={{width:'150px'}} value={this.state.firstname} onChange={this.handleChange} />
					<br/><br/>	
					<label><h2 >Last Name</h2></label>						
					<input name="lastname" id="lastname" style={{width:'150px'}} value={this.state.lastname} onChange={this.handleChange} />														
					<br/><br/>					
					<label><h2 >Subject</h2></label>						
					<input name="compname" id="compname" style={{width:'150px'}} value={this.state.compname} onChange={this.handleChange} />														
					<br/><br/>
					<label><h2 >Email</h2></label>						
					<input name="email" id="email" style={{width:'150px'}} value={this.state.email} onChange={this.handleChange} />														
					<br/><br/>	
					<label><h2 >Contact Information</h2></label>						
					<textarea name="comments" id="comments" rows="5" value = {this.state.comments} onChange={this.handleChange} /><br/><br/>
					<button type="submit" className="btn btn-primary mr-2" width="200px">&nbsp;Submit &nbsp;</button> &nbsp;&nbsp;<br/><br/>
					<h2>{this.state.Resp=="" ? "":this.state.Resp}</h2>
				</form>
			</div>
		)
	}
}

export default contactForm;